import React from "react";
import CustomNavbar from "../Inbox/CustomNavbar";
import Sidebar from "../Inbox/SideBar";

const Inbox = () => {
  return (
    <>
      <CustomNavbar />
      <Sidebar />
    </>
  );
};

export default Inbox;
